<!-- <dashboardnav> -->
  
    <cradua-pipeline-asset-location
    [pipelineassetlocations]="pipelineassetlocations$ | async"
    (pipelineassetlocation)="onSubmitPipelineAssetLocation($event)"
    (deletePipelineAssetLocationEvent)="onDeletePipelineAssetLocation($event)"
    *ngIf="(isLoadingPipelineAssetLocation$ | async ) === false"
    >
  </cradua-pipeline-asset-location>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoadingPipelineAssetLocation$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  <!-- </dashboardnav> -->
  